<template>
  <user-input-button
    :active-color="toggle ? (speaking ? 'red' : '#8B0000') : '#01509F'"
    @click.native.prevent="
      toggle ? endSpeechRecognition() : startSpeechRecognition()
    "
  >
  </user-input-button>
</template>

<script>
import UserInputButton from './UserInputButton'
import MessageHandlerMixin from '../mixins/MessageHandlerMixin'
import Recorder from '@/assets/lib/recorder'
import '@/assets/lib/vad'

const SpeechRecognition =
  window.SpeechRecognition || window.webkitSpeechRecognition
let recognition = SpeechRecognition ? new SpeechRecognition() : false

export default {
  name: 'SpeechToText',
  components: { UserInputButton },
  mixins: [MessageHandlerMixin],
  props: {
    sessionId: {
      type: String
    },
    lang: {
      type: String,
      default: 'en-US'
    },
    text: {
      type: [String, null],
      required: true
    }
  },
  data() {
    return {
      error: false,
      speaking: false,
      toggle: false,
      runtimeTranscription: '',
      sentences: [],
      mediaRecorder: {},
      isRecording: false,
      analyser: undefined
    }
  },
  mounted() {
    this.checkCompatibility()
  },
  methods: {
    checkCompatibility() {
      if (!recognition) {
        this.error =
          'Speech Recognition is not available on this browser. Please use Chrome or Firefox'
      }
    },
    endSpeechRecognition() {
      const currentSelectedSpeech = localStorage.getItem('speech')
        ? localStorage.getItem('speech')
        : this.$store.state.speech

      if (currentSelectedSpeech === 'deep') {
        this.isRecording = false
        this.toggle = false
        this.audioContext.close().then(() => {
          console.log('streaming close')
        })
        this.$store.state.currentAvatar = 'still'
      } else {
        recognition.stop()
        recognition = SpeechRecognition ? new SpeechRecognition() : false
        this.toggle = false
        this.$emit('speechend', {
          sentences: this.sentences,
          text: this.text + this.sentences.join('. ')
        })
        this.$store.state.currentAvatar = 'still'
      }
    },
    startSpeechRecognition() {
      const currentSelectedSpeech = localStorage.getItem('speech')
        ? localStorage.getItem('speech')
        : this.$store.state.speech

      if (currentSelectedSpeech === 'deep') {
        this.$store.state.currentAvatar = 'listening'
        const vm = this
        this.toggle = true
        window.AudioContext = window.AudioContext || window.webkitAudioContext
        this.audioContext = new AudioContext({ sampleRate: 16000 })
        this.isRecording = true

        navigator.getUserMedia =
          navigator.getUserMedia ||
          navigator.mozGetUserMedia ||
          navigator.webkitGetUserMedia

        navigator.getUserMedia({ audio: true }, vm.startUserMedia, e => {
          console.log(`No live audio input in this browser: ${e}`)
        })
      } else {
        if (!recognition) {
          this.error =
            'Speech Recognition is not available on this browser. Please use Chrome or Firefox'
          return false
        }
        this.toggle = true
        recognition.lang = this.lang
        recognition.interimResults = true

        recognition.start()

        // eslint-disable-next-line no-unused-vars
        recognition.addEventListener('speechstart', event => {
          this.speaking = true
        })

        // eslint-disable-next-line no-unused-vars
        recognition.addEventListener('speechend', event => {
          this.speaking = false
        })

        recognition.addEventListener('result', event => {
          this.runtimeTranscription = Array.from(event.results)
            .map(result => result[0])
            .map(result => result.transcript)
            .join('')
        })

        recognition.addEventListener('end', () => {
          if (this.runtimeTranscription !== '') {
            this.sentences.push(
              this.capitalizeFirstLetter(this.runtimeTranscription)
            )
            this.$emit(
              'update:text',
              `${this.text}${this.sentences.slice(-1)[0]}. `
            )
            this.sentences = []
          }
          this.runtimeTranscription = ''
          recognition.stop()
          if (this.toggle) {
            // keep it going.
            recognition.start()
          }
          recognition.start()
          this.$store.state.currentAvatar = 'listening'
        })
      }
    },
    startUserMedia(stream) {
      const vm = this
      vm.analyser = vm.audioContext.createAnalyser()
      const source = vm.audioContext
        .createMediaStreamSource(stream)
        .connect(vm.analyser)

      vm.dataArray = new Uint8Array(vm.analyser.fftSize / 32)

      vm.mediaRecorder = new Recorder(source, { numChannels: 1 })
      vm.mediaRecorder.record()
      window.setTimeout(() => {
        if (vm.mediaRecorder.state === 'recording') {
          vm.mediaRecorder.stop()
          console.log('10 seconds, stop recording')
        }
      }, 10000)
      // Setup options
      const options = {
        source: source,
        voice_stop: function() {
          if (vm.isRecording) {
            vm.mediaRecorder.stop()
            vm.mediaRecorder.exportWAV(vm.createFileLink)
            vm.endSpeechRecognition()
            console.log('voice_stop')
          }
        },
        voice_start: function() {
          if (vm.isRecording) {
            console.log('voice_start')
          }
        }
      }
      // eslint-disable-next-line no-undef,no-unused-vars
      const vad = new VAD(options)
    },
    createFileLink(blob) {
      const vm = this
      const sessionId = this.sessionId

      console.log('recorder stopped')

      this.waitForRespose = true
      const audioURL = window.URL.createObjectURL(blob)

      const request = new XMLHttpRequest()
      request.open('GET', audioURL, true)
      request.responseType = 'blob'
      request.onload = function() {
        const reader = new FileReader()
        reader.readAsDataURL(request.response)
        reader.onload = function(el) {
          vm.sendMessageToBot(el.target.result, sessionId)
        }
      }
      request.send()
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    }
  }
}
</script>

<style scoped></style>
